import React, { useEffect, useState } from 'react'
import { Routes, Route, useNavigate, useLocation, matchPath } from 'react-router-dom';
import { Page, Header, Button, icons } from 'daymap-library';
import Settings from '../Settings/Settings';
import { VisitorProvider } from './visitorContext';
import SignOut from './SignOut/SignOut';
import SignIn from './SignIn/SignIn';
import { useApp } from '../../helpers/appContext';
import { useAuth } from '../../helpers/authContext';
import { SchoolLogo } from '../../components/Logo/Logo';
import styles from './Visitors.module.scss';

const menus = [
    { id: 0, text: 'Change Mode', iconCode: icons.ICON_CSS_CLASS.Switch},
    { id: 1, text: 'Settings', iconCode: icons.ICON_CSS_CLASS.Settings},
]

function Visitors() {
    const { setAppType, setMode} = useApp();
    const { signOutMenu } = useAuth();
    const [settingsOpen, setSettingsOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const backButtonClicked = () => {
        const { pathname } = window.location;
        const page = pathname.substring(pathname.lastIndexOf('/'));

        switch (page) {
            case '/in':
            case '/out':
                navigate('/visitors');
                break;
            case '/visitors':
                navigate('/');
                break;
            default:
                break;
        }
    }

    let onBackButtonClick = !matchPath('/visitors', location.pathname) ? () => backButtonClicked() : null;

    const backgroundStyle = {
        backgroundImage: `url(${SchoolLogo()})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        backgroundPosition: 'right'
    };

    return (
        <VisitorProvider>
            <Page hasHeader center style={backgroundStyle}>
                {settingsOpen && <Settings onClose={() => setSettingsOpen(false)} />}
                <Header title="Visitors" onBackButtonClick={onBackButtonClick} menus={signOutMenu && [signOutMenu]} />
                <Routes>
                    <Route path="/" element={<VisitorHome />} />
                    <Route path="/out" element={<SignOut />} />
                    <Route path="/in" element={<SignIn />} />
                </Routes>
            </Page>
        </VisitorProvider>
    )
}

const VisitorHome = () => {
    const navigate = useNavigate();

    useEffect(() => {
    }, []);

    return (
        <div className={styles.VisitorsHome}>
            <SchoolLogo />
            <div>
                <Button text="Sign In" large onClick={() => navigate('in')}></Button>
                <Button text="Sign Out" large onClick={() => navigate('out')}></Button>
            </div>
        </div>
    )
}



export default Visitors